import { createFileRoute, Outlet } from '@tanstack/react-router'
import { stockTransferQueryOptions } from '../../../../features/inventory/queries'

export const Route = createFileRoute('/_app/stock-transfers/$transferId')({
  staticData: { crumb: 'stockTransfer' },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(stockTransferQueryOptions(params.transferId)),
  component: Outlet,
})
